import RepeaterWidget from './RepeaterWidget';
import { Config } from './types';
import RepeaterWidgetControl from './RepeaterWidgetControl';
import {
  defaultBackgroundData,
  defaultBackgroundImageData,
  defaultBorderData,
  defaultRepeaterWidgetLocationData,
  RepeaterWidgetInitialData,
} from 'builder/util/constants';

export default ({
  type: 'RepeaterWidget',
  displayName: 'Repeater',
  icon: 'pipe-section',
  initialConfig: {
    ...defaultBackgroundData,
    ...defaultBackgroundImageData,
    ...defaultRepeaterWidgetLocationData,
    ...defaultBorderData,
    uniqueId: 'repeater123',
    lineColor: 'black',
    visible: true,
    containerCount: 3,
    repeaterData: RepeaterWidgetInitialData,
    enableFiltering: false,
    filterBy: '',
    repeaterDataMapping: {} as any,
    widgetDataConnections: {
      1: 'Card Name',
      2: 'Card Description',
      3: 'Description',
      4: 'Link1',
      5: 'Link2',
      6: 'Image1',
    },
    imageColumnNames: ['Image1'],
    layout: 'horizontal',
    itemsCount: 3,
    enablePagination: false,
    paginatedItemsPerPage: 9,
    currentPaginationPage: 1,

    // Sidebar styling defaults using typography objects
    sidebarBackgroundColor: '#f3f3f3',
    sidebarHeadingFont: 'OptumSans',
    sidebarHeadingFontSize: '14',
    sidebarHeadingBold: true,
    sidebarHeadingItalic: false,
    sidebarHeadingUnderline: false,
    sidebarHeadingStrikeThrough: false,
    sidebarHeadingTextColor: '#1d1929',

    sidebarOptionFont: 'OptumSans',
    sidebarOptionFontSize: '14',
    sidebarOptionBold: false,
    sidebarOptionItalic: false,
    sidebarOptionUnderline: false,
    sidebarOptionStrikeThrough: false,
    sidebarOptionTextColor: '#1d1929',

    checkboxButtonColor: '#002677',

    // Container spacing defaults
    containerHorizontalSpacing: 33,
    containerVerticalSpacing: 23,
  },
  components: {
    render: RepeaterWidget,
    control: RepeaterWidgetControl,
  },
  copyable: true,
} as unknown) as HorizonWidgetDefinition<Config>;

export { RepeaterWidget };
